// import { useState } from 'react';
/////////////////////////////////////////////////////////////
// import { useCustomSelector } from '@/core/redux/hooks';
import { Hacks, Energy, LevelProgress } from '@/app/shared/components';

export const NinjaProgress: React.FC = () => {
	/*********************
	// #region Hooks
	**********************/

	/*********************
	// #region Redux
	**********************/
	// const { level } = useCustomSelector((state) => state.counter);

	/*********************
	// #region States
	**********************/

	/*********************
	// #region Functions  
	**********************/

	/*********************
	// #region Template 
	**********************/
	return (
		<div className="absolute mx-4 left-0 sm:left-auto right-0 sm:pl-4 bottom-[130px] sm:bottom-[30px] grid grid-cols-5 gap-4 items-end ">
			<LevelProgress />
			<Hacks />
			<Energy />
		</div>
	);
};
